<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T15:08:56+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Aboutus page
@Last modified by:   tom
@Last modified time: 2019-06-07T14:13:06+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>
  <c-page
    id="aboutus"
    :title="$t('about_us.header.title')"
    :jbheader="$t('about_us.header.subtitle')"
    :jblead="$t('about_us.header.lead')"
    jbvariant="primary"
    :sideimage="require('@/assets/img/career/team.jpg')"
  >
    <!-- Intro -->
    <h2 class="text-secondary">{{ $t('about_us.specialize.title') }}</h2>
    <b-row>
      <b-col sm="7" class="pr-0">
        <p v-html="$t('about_us.body.intro')" />
        <p v-html="$t('about_us.specialize.slot')" />
      </b-col>
      <b-col class="text-center">
        <uli labelkey="about_us.body.usp" />
      </b-col>
    </b-row>

    <!-- Office philosophy -->
    <!-- <h2 class="text-secondary">{{ $t('about_us.office.title') }}</h2>
    <p v-html="$t('about_us.office.slot')"/>
    <b-card-group id="officecards" deck>
      <b-card
        v-for="f in 2"
        :key = "f"
        :title = "$t('about_us.office.' + f + '.type')"
        :sub-title = "$t('about_us.office.' + f + '.purpose')">
        <lzimg
          :src="'img/aboutus/'+ $t('about_us.office.' + f + '.img')"
          :alt="'[' + $t('about_us.office.' + f + '.type') + ']'"
          fluid
          width="400"
          height="250"
          blank-color="#bbb"
          zoom-modal />
        <p class="font-weight-light" v-html="$t('about_us.office.' + f + '.slot')"/>
        <blockquote v-html="$t('about_us.office.' + f + '.block')"/>
      </b-card>
    </b-card-group> -->

    <!-- The team -->
    <h2 class="text-secondary">{{ $t('about_us.team.title') }}</h2>
    <p v-html="$t('about_us.team.intro')" />

    <!-- <b-card-group id="managementcards" deck> -->
    <b-card v-for="f in 1" :key="f" class="mb-2">
      <b-row>
        <b-col cols="3">
          <!-- cols width is for photo @/assets/img/logo/Qrespi-Logo-m.svg-->
          <img
            :src="require('@/assets/img/aboutus/' + $t('about_us.team.' + f + '.label') + '.jpg')"
            fluid
            width="100"
            height="100"
          />
        </b-col>
        <b-col>
          <!-- width is remainder -->
          <h5>{{ $t('about_us.team.' + f + '.name') }}</h5>
          <p>{{ $t('about_us.team.' + f + '.title') }}</p>
        </b-col>
      </b-row>
      <hr />
      <p class="font-weight-light" v-html="$t('about_us.team.' + f + '.slot')" />
    </b-card>
    <!-- </b-card-group> -->

    <!-- Work with us -->
    <hr />
    <b-row>
      <b-col>
        <h3 class="text-secondary">{{ $t('about_us.work.title') }}</h3>
        <p v-html="$t('about_us.work.caption')" />
        <router-link
          :to="{ name: 'career' }"
          class="btn btn-info float-right mr-sm-2 btn-sm nav-item nav-last "
        >
          {{ $t('about_us.work.interested') }}
        </router-link>
      </b-col>
    </b-row>
  </c-page>
</template>

<script>
export default {
  name: 'Aboutus'
}
</script>

<style lang="scss" scoped>
#aboutus {
  #managementcards {
    font-size: 0.9em;
    .card-img-top {
      width: 100px;
      height: 100px;
      margin-top: 20px;
      margin-left: 20px;
    }
    .card-title {
      margin-top: 0 !important;
    }
  }
}
</style>
